<div class="breadcrumb-header justify-content-between">
  <div class="my-auto">
    <div class="d-flex">
      <h4 class="content-title mb-0 my-auto">Seguridad (Accesos usuarios)</h4>
      <span class="text-muted mt-1 tx-13 ms-2 mb-0">/ Configuración simple de accesos</span>
    </div>
  </div>

  <div class="d-flex my-xl-auto right-content align-items-center gap-2 flex-wrap">
    <button class="btn btn-outline-secondary" type="button" (click)="editarPerfil()" [disabled]="!selectedProfile || guardando || !canUpdateProfiles">
      Editar perfil
    </button>
    <button class="btn btn-danger" type="button" (click)="eliminarPerfil()" [disabled]="!selectedProfile || guardando || !canDeleteProfiles">
      Eliminar perfil
    </button>
    <button class="btn btn-secondary" type="button" (click)="crearPerfil()" [disabled]="guardando || !canCreateProfiles">
      Nuevo perfil
    </button>
  </div>
</div>

<div class="row row-sm">
  <div class="col-lg-4 col-xl-3">
    <div class="card profile-list-card">
      <div class="card-body">
        <h6 class="mb-3">Perfiles</h6>

        @if (cargandoPerfiles) {
          <div class="text-center py-3">
            <div class="spinner-grow" role="status"></div>
            <p class="mt-2 mb-0">Cargando perfiles...</p>
          </div>
        }

        @if (!cargandoPerfiles && profiles.length === 0) {
          <div class="empty-state small-empty">
            <div class="empty-state__icon"><i class="fa fa-users"></i></div>
            <h6 class="mb-1">Sin perfiles</h6>
            <p class="mb-0">Crea tu primer perfil.</p>
          </div>
        }
        

        @if (!cargandoPerfiles && profiles.length > 0) {
          <div class="row align-items-center g-2 mb-3">
            <div class="col-8">
              <input
                type="text"
                class="form-control form-control-sm"
                [(ngModel)]="busquedaPerfil"
                (ngModelChange)="onBusquedaPerfilChange()"
                placeholder="Buscar perfil (nombre o ID)">
            </div>
            <div class="col-4 text-end">
              <small class="text-muted">{{ perfilesFiltrados.length }} visibles</small>
            </div>
          </div>

          <div class="profile-list">
            @for (profile of perfilesPaginados; track profile) {
              <div class="profile-item" [class.active]="selectedProfile?.id === profile.id">
                <button
                  type="button"
                  class="profile-main-btn"
                  (click)="seleccionarPerfil(profile)">
                  <span>{{ profile.name }}</span>
                  <small>ID {{ profile.id }}</small>
                </button>
                <button
                  type="button"
                  class="btn btn-sm btn-outline-secondary profile-users-btn"
                  (click)="verUsuariosPerfil(profile)"
                  [disabled]="!canReadUsers">
                  Usuarios
                </button>
              </div>
            }
          </div>

          @if (perfilesFiltrados.length > 0) {
            <div class="profiles-pagination">
              <button
                type="button"
                class="btn btn-sm btn-outline-secondary"
                (click)="cambiarPaginaPerfiles(-1)"
                [disabled]="paginaPerfilesActual <= 1">
                Anterior
              </button>
              <small class="text-muted">
                Página {{ paginaPerfilesActual }} / {{ totalPaginasPerfiles }}
              </small>
              <button
                type="button"
                class="btn btn-sm btn-outline-secondary"
                (click)="cambiarPaginaPerfiles(1)"
                [disabled]="paginaPerfilesActual >= totalPaginasPerfiles">
                Siguiente
              </button>
            </div>
          }

          @if (perfilesFiltrados.length === 0) {
            <div class="empty-state small-empty mt-3">
              <div class="empty-state__icon"><i class="fa fa-search"></i></div>
              <h6 class="mb-1">Sin resultados</h6>
              <p class="mb-0">No hay perfiles que coincidan.</p>
            </div>
          }
        }
      </div>
    </div>
  </div>

  <div class="col-lg-8 col-xl-9">
    <div class="card permission-card">
      <div class="card-body">
        <div class="permission-header">
          <div>
            <h6 class="mb-1">Pantallas habilitadas</h6>
            @if (selectedProfile) {
              <p class="mb-0 text-muted">
                Perfil seleccionado: <b>{{ selectedProfile.name }}</b>
              </p>
            }
            @if (!selectedProfile) {
              <p class="mb-0 text-muted">
                Selecciona un perfil para habilitar pantallas.
              </p>
            }
          </div>

          <div class="permission-actions">
            <span class="badge rounded-pill bg-light text-dark">{{ totalPantallasSeleccionadas }} pantallas</span>
            <button class="btn btn-secondary" type="button" (click)="guardarPermisosPerfil()" [disabled]="!selectedProfile || guardando || !canUpdateProfilePermissions">
              {{ guardando ? 'Guardando...' : 'Guardar' }}
            </button>
          </div>
        </div>

        @if (selectedProfile) {
          <div class="alert alert-info mb-3">
            Acceso base incluido por defecto: <b>Consulta de órdenes</b>.
          </div>
        }

        @if (selectedProfile) {
          <div class="quick-actions">
            <button class="btn btn-sm btn-outline-secondary" type="button" (click)="seleccionarTodo()" [disabled]="!canUpdateProfilePermissions">
              Seleccionar todas
            </button>
            <button class="btn btn-sm btn-outline-danger" type="button" (click)="limpiarTodo()" [disabled]="!canUpdateProfilePermissions">
              Limpiar todas
            </button>
          </div>
        }

        @if (pantallas.length > 0) {
          <div class="row align-items-center g-2 mb-3 mt-1">
            <div class="col-md-8">
              <input
                type="text"
                class="form-control"
                [(ngModel)]="busquedaPantalla"
                placeholder="Buscar pantalla (ej: órdenes, tomografías, físicas)...">
            </div>
            <div class="col-md-4 text-md-end">
              <small class="text-muted">{{ pantallasFiltradas.length }} pantallas visibles</small>
            </div>
          </div>
        }

        @if (cargandoPermisos) {
          <div class="text-center py-4">
            <div class="spinner-grow" role="status"></div>
            <p class="mt-2 mb-0">Cargando configuración...</p>
          </div>
        }

        @if (!cargandoPermisos && pantallasFiltradas.length === 0) {
          <div class="empty-state small-empty">
            <div class="empty-state__icon"><i class="fa fa-search"></i></div>
            <h6 class="mb-1">Sin resultados</h6>
            <p class="mb-0">No hay pantallas que coincidan.</p>
          </div>
        }

        @if (!cargandoPermisos && pantallasFiltradas.length > 0) {
          <div class="screen-grid">
            @for (pantalla of pantallasFiltradas; track pantalla) {
              <div class="screen-card" [class.disabled]="!pantallaDisponible(pantalla)">
                <div class="screen-head">
                  <div class="screen-check">
                    <input
                      type="checkbox"
                      [checked]="isPantallaChecked(pantalla)"
                      [indeterminate]="isPantallaPartial(pantalla)"
                      (change)="togglePantalla(pantalla, $event)"
                      [disabled]="!selectedProfile || !canUpdateProfilePermissions || !pantallaDisponible(pantalla)">
                  </div>
                  <div class="screen-content">
                    <div class="screen-title">{{ pantalla.label }}</div>
                    <div class="screen-description">{{ pantalla.description }}</div>
                  </div>
                  @if (pantalla.children && pantalla.children.length > 0) {
                    <button
                      type="button"
                      class="collapse-toggle"
                      (click)="toggleCollapse(pantalla.key)">
                      <i class="bi" [class.bi-chevron-down]="isCollapsed(pantalla.key)" [class.bi-chevron-up]="!isCollapsed(pantalla.key)"></i>
                      {{ isCollapsed(pantalla.key) ? 'Ver opciones' : 'Ocultar' }}
                    </button>
                  }
                </div>
                @if (pantalla.children && pantalla.children.length > 0 && !isCollapsed(pantalla.key)) {
                  <div class="screen-children">
                    @for (child of pantalla.children; track child) {
                      <div class="screen-child">
                        <div class="screen-check">
                          <input
                            type="checkbox"
                            [checked]="isPantallaChecked(child)"
                            [indeterminate]="isPantallaPartial(child)"
                            (change)="togglePantalla(child, $event)"
                            [disabled]="!selectedProfile || !canUpdateProfilePermissions || !pantallaDisponible(child)">
                        </div>
                        <div class="screen-content">
                          <div class="screen-title child-title">{{ child.label }}</div>
                          <div class="screen-description">{{ child.description }}</div>
                        </div>
                      </div>
                    }
                  </div>
                }
              </div>
            }
          </div>
        }
      </div>
    </div>
  </div>
</div>
